import React, { useEffect, useMemo, useState } from 'react';
import { Box, Checkbox, CircularProgress, Paper, TextField, Typography } from '@mui/material';
import { format } from 'date-fns';
import useFetch from '../../../../hooks/useFetch.js';
import { getV2Competitions, postV2Live, postV2Team } from '../../../../../api/index.js';
import CompetitionDTO from '../../../../DTO/CompetitionDTO.js';
import SearchFilterDTO from '../../../../DTO/SearchFilterDTO.js';
import LiveDTO from '../../../../DTO/LiveDTO.js';
import { useNavigate } from 'react-router-dom';
import { getUserProvider } from '../../../../../actions/auth.js';
import { useNotifications } from '../../../../notifications/NotificationManager.js';
import { getRootUrl } from '../../../../../api/infoEnv.js';
import Button from '../../../../components/Button.js';
import TeamDTO from '../../../../DTO/TeamDTO.js';
import SelectDisciplines from '../../../../components/SelectDisciplines.js';
import SelectNationality from '../../../../components/SelectNationality.js';

const defaultTeamData = new TeamDTO({ name : "", nationality : "", disciplines : [], provider : getUserProvider() })

const FormTeam = ({ team = defaultTeamData }) => {

    const navigate = useNavigate()

    const { addNotification } = useNotifications();

    const [formTeam, setFormTeam] = useState(team)

    const { data, isLoading, error, fetchData } = useFetch(postV2Team, [[formTeam]]);

    useEffect(() => {

        if(!data)
            return

        // Envoyer une notif au service de notification
        addNotification({
            title: formTeam._id ? 'Edition d\'une équipe' : 'Création d\'une équipe',
            type: 'success',
            description: 'Votre équipe a été ' + (formTeam._id ? 'modifiée' : 'créée') + ' avec succès !',
            //link: getRootUrl() +'/live/'+data._id+'/calendar'
        });

        // Rediriger vers la page des joueurs
        navigate("/multisport/actors/teams");

    }, [data])

    useEffect(() => {

        if(!error)
            return

        // Envoyer une notif au service de notification
        addNotification({
            title: formTeam._id ? 'Edition d\'une équipe' : 'Création d\'une équipe',
            type: 'error',
            description: error.status + ' - ' + error.message,
            //link: getRootUrl() +'/live/'+data._id+'/calendar'
        });

    }, [error])

    const handleChange = (e) => {

        const {name, value} = e.target

        setFormTeam(s => ({...s, [name] : value}))
    }

    const isValidForm = useMemo(() => {
        return formTeam.name && formTeam.nationality &&
        formTeam.disciplines && formTeam.disciplines.length > 0 && !formTeam.disciplines.some(discipline => !discipline._id) && 
        formTeam.provider

    }, [formTeam])

    const handleSubmit = async () => {
        // Controles du form
        if(!isValidForm)
            return

        fetchData()
    }


    if(isLoading)
        return <CircularProgress/>

    return <Paper sx={{ p: 3, maxWidth: 600, mx: "auto" }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
                <Typography variant="h5" sx={{ mb: 4 }}>
                    {formTeam._id  ? "Edition" : "Création"} d'une équipe
                </Typography>
                
                <Box sx={{ width: '100%', maxWidth: 400, mb: 2 }}>
                    <TextField
                    fullWidth
                    name="name"
                    label="Nom"
                    onChange={handleChange}
                    value={formTeam.name ? formTeam.name : ''}
                    sx={{ mb: 2 }}
                    />
                    <Box sx={{ mb: 2 }}>
                    <SelectNationality
                        name="nationality"
                        selectedNationality = {formTeam.nationality ? formTeam.nationality : ''}
                        handleChange={handleChange}
                       // value={formTeam.nationality ? formTeam.nationality : ''}
                    />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                    <SelectDisciplines
                        selectedDisciplines={formTeam.disciplines}
                        handleChange={handleChange}
                        name="disciplines"
                    />
                    </Box>
                </Box>
                
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    disabled={!isValidForm}
                >
                    VALIDER MON FORMULAIRE
                </Button>
                </Box>
            </Paper>

}

export default FormTeam